export default {
      id: "FunctionTrunkLeft-usage",
      viewBox: "0 0 54 54.00001",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#FunctionTrunkLeft",
      toString: function () {
        return this.url;
      }
    }